import Vue from 'vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';

import '@fortawesome/fontawesome-free/css/solid.css';
import '@fortawesome/fontawesome-free/css/fontawesome.css';

library.add(fas);

// import {
//   faEdit,
//   faPencilAlt,
//   faBars,
//   faTimes,
//   faTimesCircle,
//   faPlus,
//   faPlusCircle,
//   faMinus,
//   faMinusCircle,
//   faArrowLeft,
//   faArrowRight,
//   faCaretRight,
//   faAngleDown,
//   faTrashAlt,
//   faBox,
//   faHome,
//   faBook,
//   faBookOpen,
//   faAt,
//   faSearch,
//   faBrain,
//   faSave,
//   faProjectDiagram,
//   faCheck,
//   faFolder,
//   faFolderOpen,
//   faFolderPlus,
//   faFile,
// } from '@fortawesome/free-solid-svg-icons';
//
// library.add(faEdit);
// library.add(faPencilAlt);
// library.add(faBars);
// library.add(faTimes);
// library.add(faTimesCircle);
// library.add(faPlus);
// library.add(faPlusCircle);
// library.add(faMinus);
// library.add(faMinusCircle);
// library.add(faArrowLeft);
// library.add(faArrowRight);
// library.add(faCaretRight);
// library.add(faAngleDown);
// library.add(faTrashAlt);
// library.add(faBox);
// library.add(faHome);
// library.add(faBook);
// library.add(faBookOpen);
// library.add(faAt);
// library.add(faSearch);
// library.add(faBrain);
// library.add(faSave);
// library.add(faProjectDiagram);
// library.add(faCheck);
// library.add(faFolder);
// library.add(faFolderOpen);
// library.add(faFolderPlus);
// library.add(faFile);

Vue.component('font-awesome-icon', FontAwesomeIcon);
